// Preserve explicit LaTeX and group Unicode subscripts so multi-digit indices render correctly.
export function normalizePreviewLabel(label) {
 return String(label ?? '').replace(/[₀₁₂₃₄₅₆₇₈₉ₐₑₒₓₕₖₗₘₙₚₛₜᵢⱼᵣᵤᵥ]+/g, index => {
  const from = '₀₁₂₃₄₅₆₇₈₉ₐₑₒₓₕₖₗₘₙₚₛₜᵢⱼᵣᵤᵥ';
  const to = '0123456789aeoxhklmnpstijruv';
  return '_{' + [...index].map(char => to[from.indexOf(char)]).join('') + '}';
 });
}
